export const SET_USER_LOGIN = "SET_USER_LOGIN"
export const SET_USER_DATA = "SET_USER_DATA"
export const CLEAR_USER = "CLEAR_USER"